//@ts-nocheck
//needs checking because of props
import React from 'react'
import { connect, DefaultRootState } from 'react-redux'
import { Grid, Segment } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
import createAction from 'loankeeper-common/helpers/createAction'
import { LKHeader } from 'loankeeper-common/components'
//@ts-ignore
import { GridContainer, FakeInput } from 'shared/StyledComponents'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { translateBase } from '../../helpers'
import { actions, REDUCER_NAME } from './constants'
import { ClientEditTrigger } from '../../../ClientEdit'
import { ClientInfoProps } from '../../types'
const getSelects = (state: DefaultRootState) => state[REDUCER_NAME].selects

const WORD_CITY = 'ქალაქი'
const WORD_GEORGIA = 'საქართველო'

@withConstantPermissions()
//@ts-ignore
@connect(
  (state) => ({
    selects: getSelects(state),
  }),
  (dispatch) => ({
    fetchSelects: () => {
      dispatch(createAction(actions.client.FETCH))
    },
  }),
)
class ClientInfo extends React.PureComponent<ClientInfoProps> {
  componentDidMount() {
    this.props.fetchSelects()
  }

  getCity() {
    try {
      const { City } = this.props.selects
      const { Registration_ActiveAddress: address } = this.props.data

      let city
      const parts = address.split(',')
      let cityName = parts.shift()
      if (cityName) {
        cityName = cityName.trim().replace(WORD_CITY, '').trim()
        city = City.find((x) => x.Title === cityName)
      }

      if (!city) {
        cityName = parts.shift()
        if (cityName) {
          cityName = cityName.trim().replace(WORD_CITY, '').trim()
        }
        city = City.find((x) => x.Title === cityName)
      }

      return (city && city.Title) || City[0].Title
    } catch (error) {
      return ''
    }
  }

  getActiveAddress() {
    try {
      let { Registration_ActiveAddress: address } = this.props.data
      const city = this.getCity()

      if (city && address.includes(city)) {
        address = address.replace(city, '').replace(WORD_CITY, '').replace(WORD_GEORGIA, '')
        address = address.replace(/^[ ,]+|[ ,]+$/g, '')
      }

      return address
    } catch (error) {
      return ''
    }
  }

  render() {
    const { data, selects, base, permissions } = this.props
    return (
      <div>
        {data.ResultStatus_Code && data.ResultStatus_Code === 14 ? (
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={12}>
                  <GridContainer>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_ID_number')}
                        </Grid.Column>

                        <Grid.Column width={6}>
                          <FakeInput className={base.CardNumber !== data.PrivateNumber ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{data.PrivateNumber}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>

                        <Grid.Column width={6}>
                          <FakeInput
                            className={base.IDSerial !== data.Document_Serial + data.Document_Number ? 'error' : ''}
                          >
                            <Segment>
                              <LKHeader size="small">{data.Document_Serial + data.Document_Number}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_firstname')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.FName !== data.Person_FirstName ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{data.Person_FirstName}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_lastname')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.LName !== data.Person_LastName ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{data.Person_LastName}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_pers_dob')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.DOB !== data.Person_BirthDate ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{LKDate.from(data.Person_BirthDate).toString()}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_birthplace')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.BirthPlace !== data.Person_BirthPlace ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{data.Person_BirthPlace}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_sex_t')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.SexID !== data.Person_GenderID ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">
                                {data.Person_GenderID === null && selects && selects.Gender && selects.Gender.length
                                  ? selects.Gender[0].Title
                                  : data.Person_GenderID}
                              </LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_address')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.Address !== this.getActiveAddress() ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{this.getActiveAddress()}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_city')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.City !== this.getCity() ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{this.getCity()}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_addr_status')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput>
                            <Segment>
                              <LKHeader size="small">{data.Registration_AddrStatus}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_idcardissuer2')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.IDCardIssuer !== data.Document_IssuerName ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{data.Document_IssuerName}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_id_card_issue_date')}
                        </Grid.Column>

                        <Grid.Column width={6}>
                          <FakeInput className={base.IDCardRegDate !== data.Document_IssueDate ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{LKDate.from(data.Document_IssueDate).toString()}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>

                        <Grid.Column width={6}>
                          <FakeInput className={base.IDValidityDate !== data.Document_ValidDate ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{LKDate.from(data.Document_ValidDate).toString()}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_citizenship')}
                        </Grid.Column>

                        <Grid.Column width={12}>
                          <FakeInput className={base.Citizenship !== data.Person_CitizenshipCountry ? 'error' : ''}>
                            <Segment>
                              <LKHeader size="small">{data.Person_CitizenshipCountry}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                          {translateBase('lbl_cra_status')}
                        </Grid.Column>

                        <Grid.Column width={6}>
                          <FakeInput>
                            <Segment>
                              <LKHeader size="small">{data.Document_StatusName}</LKHeader>
                            </Segment>
                          </FakeInput>
                        </Grid.Column>

                        <Grid.Column width={6}>
                          {permissions.EDIT_CLIENT && (
                            <ClientEditTrigger
                              name="ClientEditInClientDetails"
                              ID={base.ID}
                              hash={base.HashSum_ClientID_}
                              clientType={base.ClientTypeID}
                              fullWidth
                            >
                              {translateBase('cmd_update_client_data')}
                            </ClientEditTrigger>
                          )}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </GridContainer>
                </Grid.Column>

                <Grid.Column width={4}>
                  {data.Photo_PhotoImage.length > 0 ? (
                    <img src={`data:image/png;base64,${data.Photo_PhotoImage}`} alt="Client" />
                  ) : (
                    'Image not found'
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        ) : (
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={15}>
                  <GridContainer>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={15} textAlign="center" verticalAlign="middle">
                          <h1>
                            {data.ErrorMessage
                              ? data.ErrorMessage
                              : data.ResultStatus_Message
                              ? data.ResultStatus_Message
                              : ''}
                          </h1>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </GridContainer>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        )}
      </div>
    )
  }
}

export default ClientInfo
